<div id="intercomWidget"></div>

<!-- <div class="help-request" (click)="openHelp()" *ngIf="!showForm">
  <div class="help-request-row"><span class="fa fa-commenting-o"></span><span class="fa fa-commenting"></span> Help</div>  
</div>
<div class="help-backdrop" *ngIf="showForm"></div>
<div class="help-request-form" *ngIf="showForm">
  <div class="header"> 
    <div>{{ 'helprequest.request_help' | translate}}</div>
    <div class="fa fa-times" (click)="showForm = !showForm"></div>
  </div> 
  <div>
    <div class="row margin-top-16">
      <div class="col-12 label">{{ 'helprequest.store_name' | translate}}</div>
      <div class="col-12"><input pInputText placeholder="{{ 'helprequest.store_name' | translate}}" [(ngModel)]="storeName" [disabled]="busy || showSentMessage" /></div>
    </div>
    <div class="row margin-top-16">
      <div class="col-12 label">{{ 'helprequest.email_address' | translate}}</div>
      <div class="col-12"><input pInputText placeholder="{{ 'helprequest.email_address' | translate}}" [(ngModel)]="emailAddress" [disabled]="busy || showSentMessage" /></div>
    </div>
    <div class="row margin-top-16">
      <div class="col-12 label">{{ 'helprequest.message' | translate}}</div>
      <div class="col-12"><textarea pInputText rows="8" [(ngModel)]="message" [disabled]="busy || showSentMessage"></textarea></div>
    </div>
    <div class="row margin-top-16" *ngIf="!showSentMessage">
      <div class="col-12">
        <button [disabled]="busy || !valid()" pButton class="full-width" label="{{ 'helprequest.send_request' | translate}}"
        (click)="sendMessage()"></button>
      </div>
    </div>
    <div class="row margin-top-16" *ngIf="showSentMessage">
      <div class="col-12 sent-message">
        {{ 'helprequest.request_sent' | translate }}
      </div>
    </div>
  </div>

</div> -->